//
//
//
//
//
//
//
//
//
//

import {
  UserMixin,
  UserAuthMixin
} from "~/node_modules/sitis-nuxt/lib/mixins";
import sessionTokenGenerate from "~/helpers/sessionTokenGenerate";

export default {
  mixins: [
    UserMixin,
    UserAuthMixin
  ],

  mounted: async function () {
    await this.tgCheckAuthResponse();
  },

  methods: {
    // Авторизация через телеграм
    tgGetAuthResponse: async function () {
      this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: true});
      const authResponse = await this.$api.agent.transport.get('/oauth/signup?client=telegram')
        .then((res) => res.data)
        .catch((err) => {
          return {error: err.response?.data?.message || err.response?.message || this.$t('profile.activeNumbers.serverError')}
        });
      if (authResponse?.error) {
        this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: false});
        this.$toast.error(authResponse?.error);
        return
      }
      window.location.href = authResponse?.auth_url || '';
      this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: false});
    },
    tgCheckAuthResponse: async function () {
      const initHash = String(window?.location?.hash || "");
      if (!initHash) {
        return
      }
      if (!Boolean(initHash.includes('#tgAuthResult='))) {
        return
      }

      this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: true});
      const hashClear = String(initHash || "").replace('#tgAuthResult=', '');
      const tokenInfo = await this.$api.agent.transport.post('/oauth/callback', {
        authClient: "telegram",
        authResult: hashClear
      }).then((res) => res.data).catch((err) => {
        return {error: err.response?.data?.message || err.response?.message || this.$t('profile.activeNumbers.serverError')}
      })
      if (tokenInfo?.error) {
        this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: false});
        this.$toast.error(tokenInfo?.error);
        return
      }

      const sessionToken = sessionTokenGenerate();
      this.$api.sessionToken = sessionToken;

      const token = tokenInfo?.token;
      this.setToken({ authToken: token });
      this.$cookies.set("authToken", token, {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
      });
      this.$cookies.set("sessionToken", sessionToken, {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
      });

      await this.getUser();
      this.isSubmiting = true;

      this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: false});

      this.$router.replace(this.localePath("/profile"));
    },
  }
}
